import { getUA, getCasId } from './comFunc'

export const trackData = () => {
  const putData = {
    u_id: getCasId(),
    session_id: '',
    tracker_u: '', //外部渠道来源id 可以埋比如上页百度url'
    device_model: '', //'设备型号',
    app_version: '', //'app 版本id web 可以为空',
    screen_size: '', //'屏幕size',
    province: '', //'可不传',
    city: '', //'可不传',
    browser: getUA(), //'浏览器版本mozilla/5.0 (windows nt 10.0; win64; x64) applewebkit/537.36 (khtml, like gecko) chrome/92.0.4515.159 safari/537.36 edg/92.0.902.78',
    ip: '',
    cookies: document.cookie,
    time: new Date().getTime(),
    url: window.location.href,
    ref_url: '',
    device_id: '', //'设备id, web端获取cpuid,如果确实不好弄，则不传值',
    lan: 'zh-CN',
    os: 'pc', //'系统ios,web,pc,android',
    trackr_u: '', //外部渠道来源
    scene_code: '', //'场景编码，operation',
    scene_type: '', //'场景类型，dot_operation,',
    scene_params: '', //'不传',
    event_code: '', //'事件编码 比如实习生, 声望, 需英文下划线结构',
    event_type: 'view', //'事件类型,view',
    event_params: '', //'事件参数， 具体参考埋点方案 事件'
  }
  return putData
}

// 导航栏场景埋点字典
export const trackMap = {
  'tw-home': 'topNavigation_engine_click', // 孪生引擎
  'wd-qz': 'topNavigation_communityt_circle_click', // 语翼圈子
  'wd-task': 'topNavigation_indent_pe_click', // 轻任务
  'wd-task-center': 'topNavigation_indent_click', // 订单广场
  'wd-set': 'topNavigation_personalSettings_mySettings_click', // 接单设置
  'wd-account': 'topNavigation_personalSettings_myAccount_click', // 账户提现
  'wd-message': 'topNavigation_message_click', // 订单消息
  'wd-faq': 'topNavigation_personalSettings_helpCenter_click', // 订单帮助
  'wd-square': 'topNavigation_web_square_click', // 社区广场
  'wd-jl': 'topNavigation_personal_jl_click', // 个人简历
  'pe-personal': 'topNavigation_translate_personal_click', // 个人版
  'pe-team': 'topNavigation_translate_team_click', // 团队版
  'pe-recharge': 'topNavigation_personalSettings_digitaLassets_click', // 译力充值
  'pe-docs': 'topNavigation_personalSettings_helpCenter_click', // 工具帮助
  'pe-invite-politely': 'topNavigation_personalSettings_invitePolitely_click', // 邀请好友
  'iol-home': 'topNavigation_tool_translate_click', // 翻译工具
  'wp-class': 'topNavigation_communityt_course_click', // 课程
  'wp-recommendAll': 'topNavigation_chance_recommendAll_click', //招募聚合页
  'tsp-home': 'topNavigation_home_click', // 官方网站
  'tsp-price': 'topNavigation_translate_price_click', // 会员定价
  'tsp-version': 'topNavigation_version_click', // 版本动态
  'tsp-about': 'topNavigation_personalSettings_aboutUs_click', // 关于我们
  'tsp-center': 'topNavigation_personalCenter_personalSettings_click', // 个人中心
  'tsp-dashboard': 'topNavigation_staging_click', // 我的工作台
  'tsp-photo': 'topNavigation_head_click', // 点击头像
  'tsp-user-about': 'topNavigation_aboutUs_personalSettings_click', // 点击关于我们
  'tsp-logout': 'topNavigation_quit_personalSettings_click', // 退出登录
  'tsp-activity': 'topNavigation_communityt_activity_click', // 活动中心
  'tsp-help-center': 'topNavigation_personalSettings_helpCenter_click', // 帮助中心
}
